import { render, staticRenderFns } from "./pp-programa-editar.vue?vue&type=template&id=08548e0c&"
import script from "./pp-programa-editar.vue?vue&type=script&lang=js&"
export * from "./pp-programa-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports